import React from 'react';
import { List, Popover } from 'rsuite';

interface StatusInfoPopoverProps {
  // This property is used by Whisper component to send the animation related classNames for fading effect
  // https://github.com/rsuite/rsuite/blob/main/src/internals/Overlay/Overlay.tsx#L131-L136
  className?: string;
}

const statusItems = [
  {
    status: 'Ignored',
    description:
      'This violation will not be detected again for this specific set of details.',
  },
  {
    status: 'Suspended',
    description:
      "This violation will be paused for two weeks. If it hasn't been automatically Closed by Rentalscape after 2 weeks, it will reappear as Active.",
  },
  {
    status: 'Closed',
    description:
      'This violation has been automatically detected as resolved by Rentalscape. A seperate new violation will be raised if the issue is detected again.',
  },
];

// Ref is by Whisper component to control the visibility of the popover https://rsuitejs.com/components/whisper/#overlay
const StatusInfoPopover = React.forwardRef<
  HTMLDivElement,
  StatusInfoPopoverProps
>(({ className }: StatusInfoPopoverProps, ref) => {
  return (
    <Popover ref={ref} className={className} data-testid="status-info-popover">
      <List className="max-w-xl">
        {statusItems.map((item) => (
          <List.Item key={item.status}>
            <span className="font-bold pr-1">{item.status}</span>
            &ndash; {item.description}
          </List.Item>
        ))}
      </List>
    </Popover>
  );
});

StatusInfoPopover.displayName = 'StatusInfoPopover';

export default StatusInfoPopover;
